export default __webpack_public_path__ + "static/dgeimg-5011680238675c90173324ff2e2b53e7.png";